module.exports = new __parcel__URL__("aic_lab_level_2.c11e0d45.png").toString();